import React, { useContext } from "react";
import "./styles.css"
// import { Link } from "react-router-dom";
import ThemeContext from "./themeContext";
import languageContext from "./change-language";


const Footer = ()=>{
    const {dark} = useContext(ThemeContext);
    const {language} = useContext(languageContext);

    return(
        <div className="footer">
            <div className="footeresq"></div>
            <div className="footermeio">&copy; 2025 Nathivo's</div>
            <div className="footerdir">
                {/* <Link to="/privacy">Privacy</Link> */}<br/>
                <i className="footercontato" onClick={() => window.location = 'mailto: ivo@nathivos.com.br'}>
                    {language === "pt" ? <strong>Contato: </strong> : <strong>Contact: </strong>}
                     ivo@nathivos.com.br
                </i>
                {/* <span>
                    {language==="pt" ? "Desenvolvido por ": language==="en"? "Developed by ":"Entwickelt bei "}Ivo Biesdorf
                </span> */}
            </div>
        </div>
    )
}
export default Footer